/* eslint-disable */

export const carrierMapper = {
  methods: {
    mapperCarrier(mappingArray,form,progID) {
       let carrierdata={};
       let fields=[];
       if(form.stateCode=='AAA')
       form.stateCode=null;
       carrierdata.stateCode=form.stateCode;
       console.log('form.stateCode',form.stateCode);
       let filterProgData =  mappingArray.filter(el => el.programId == progID);
        if(filterProgData.length>0)
           {filterProgData[0].fieldMapping.forEach(mapping=>{
           var obj={};
           obj.name = mapping.carrierField;
           obj.value = Reflect.get(form, mapping.uiField)
           if(obj.value =='')
           obj.value = '<empty>';
           fields.push(obj);
         })
        }
        else
        console.log('config not available');
        carrierdata.fields=fields;
    return carrierdata;
    }
  },
};
export const none = {
  // TODO: Remove this hack that suppresses the eslint error: Prefer default export "export const uiHelpers = {""
};



// WEBPACK FOOTER //
// ./src/mixins/carrierMapper.js